import type { QuestionListItem } from '@/modules/sinarem-reports/domain/entities/question-list.entity';

export const DIFFICULTY_LABELS: Record<string, string> = {
  extra_easy: 'Muito fácil',
  easy: 'Fácil',
  medium: 'Médio',
  hard: 'Difícil',
  extra_hard: 'Muito difícil',
  unknown: 'Indefinida',
};

export const DIFFICULTY_TONE: Record<string, 'easy' | 'medium' | 'hard'> = {
  extra_easy: 'easy',
  easy: 'easy',
  medium: 'medium',
  unknown: 'medium',
  hard: 'hard',
  extra_hard: 'hard',
};

export function difficultyLabel(value?: string): string {
  if (!value) return 'Sem dados';
  return DIFFICULTY_LABELS[value] ?? value;
}

export const CHOICE_LETTERS = ['A', 'B', 'C', 'D', 'E', 'F'];

export type QuestionOptionView = {
  id: string;
  text: string;
  isCorrect: boolean;
  percent: number;
};

// Percentual calculado sobre a TURMA do control (selectionsByChoice/totalAnswers)
// — não existe "alternativa que o aluno marcou" aqui, é dado agregado.
export function optionsFromQuestion(
  question: QuestionListItem,
): QuestionOptionView[] {
  return question.choices.map((text, idx) => ({
    id: CHOICE_LETTERS[idx] ?? String(idx + 1),
    text,
    isCorrect: idx === question.correctChoice,
    percent: question.totalAnswers
      ? Math.round(
          ((question.selectionsByChoice[idx] ?? 0) / question.totalAnswers) *
            100,
        )
      : 0,
  }));
}
